<template>
    <b-container>
        <b-card bg-variant="danger" text-variant="white" v-if="filesInvalidExtensions.length > 0">
            <b-card-header>
                <b>{{ 'home.files.extension.invalid.header' | translate }}</b>
            </b-card-header>

            <b-card-body>
                {{ filesInvalidExtensions.join(', ') }}
                <br>
                <br>
                {{ 'home.files.extension.invalid.body' | translate }}

                <b-button variant="primary" class="float-right" @click="filesInvalidExtensions = []">Ok</b-button>
            </b-card-body>
        </b-card>

        <div id="file-drag-drop" v-if="!uploading && !assignedUploadSuccessful && !publicUploadSuccessful">
            <b-row>
                <b-card class="card-full-width">
                    <b-card-header>
                        <b>{{ 'home.files.select' | translate }}</b>
                    </b-card-header>

                    <b-card-body>
                        <b-form-file id="files" name="files" ref="files" v-on:change="handleFilesUpload"
                                     @input="handleFilesUpload" multiple
                                     :placeholder="$globalStore.translate('home.files.drop')"
                                     :browse-text="$globalStore.translate('home.files.drop.search')">
                            <template slot="file-name" slot-scope="{ names }">
                                {{ 'home.files.drop' | translate }}
                            </template>
                        </b-form-file>

                        <div class="text-right" style="margin-top: 5px">
                            <b-button variant="primary" @click="submitFiles()" v-show="files.length > 0">{{ 'home.upload' | translate }}</b-button>
                        </div>
                    </b-card-body>
                </b-card>
            </b-row>
            <b-row>
                <b-card class="card-full-width">
                    <b-card-header>
                        <b>{{ 'home.files.selected' | translate }}</b>
                        <div v-if="files.length > 0">{{ 'home.files.total.size' | translate }} {{ totalSize | bytes }}</div>
                    </b-card-header>

                    <b-card-body>
                        <b-form-checkbox v-model="allowPublicDownload" v-if="$globalStore.group !== 3">{{ 'home.allow.public.download' | translate }}</b-form-checkbox>

                        <multiselect v-model="selectedProjectGroup"
                                     :options="projectGroups"
                                     :multiple="false"
                                     v-bind:placeholder="$globalStore.translate('home.project.groups.placeholder')"
                                     v-bind:selectLabel="$globalStore.translate('home.selection.select.label')"
                                     v-bind:selectedLabel="$globalStore.translate('home.selection.selected.label')"
                                     v-bind:selectGroupLabel="$globalStore.translate('home.selection.select.group.label')"
                                     v-bind:deselectLabel="$globalStore.translate('home.selection.deselect.label')"
                                     v-bind:deselectGroupLabel="$globalStore.translate('home.selection.deselect.group.label')"
                                     v-on:open="onProjectGroupsSelectOpen"
                        >

                        </multiselect>

                        <multiselect v-if="$globalStore.group !== 3"
                                     v-model="selectedCustomer"
                                     :options="customers"
                                     :multiple="true"
                                     v-bind:placeholder="$globalStore.translate('home.customers.placeholder')"
                                     v-bind:selectLabel="$globalStore.translate('home.selection.select.label')"
                                     v-bind:selectedLabel="$globalStore.translate('home.selection.selected.label')"
                                     v-bind:selectGroupLabel="$globalStore.translate('home.selection.select.group.label')"
                                     v-bind:deselectLabel="$globalStore.translate('home.selection.deselect.label')"
                                     v-bind:deselectGroupLabel="$globalStore.translate('home.selection.deselect.group.label')"
                                     v-on:open="onCustomerSelectOpen"
                        >
                        </multiselect>

                        <multiselect v-model="selectedEmployee"
                                     :options="employees"
                                     :multiple="true"
                                     v-bind:placeholder="$globalStore.translate('home.employees.placeholder')"
                                     v-bind:selectLabel="$globalStore.translate('home.selection.select.label')"
                                     v-bind:selectedLabel="$globalStore.translate('home.selection.selected.label')"
                                     v-bind:selectGroupLabel="$globalStore.translate('home.selection.select.group.label')"
                                     v-bind:deselectLabel="$globalStore.translate('home.selection.deselect.label')"
                                     v-bind:deselectGroupLabel="$globalStore.translate('home.selection.deselect.group.label')"
                                     v-on:open="onEmployeeSelectOpen"

                        >
                        </multiselect>

                        <div class="table-wrapper-scroll-y">
                            <b-table responsive striped hover :items="files" :fields="filesFields">
                                <template slot="index" slot-scope="data">
                                    {{ data.index }}
                                </template>

                                <template slot="name" slot-scope="data">
                                    {{ fileNames[data.index] }}
                                </template>

                                <template slot="size" slot-scope="data">
                                    {{ data.item.size | bytes }}
                                </template>

                                <template slot="rename" slot-scope="data">
                                    <b-button size="sm" @click="renameFile(data.item)">{{ 'home.table.body.rename' | translate }}</b-button>
                                </template>

                                <template slot="remove" slot-scope="data">
                                    <b-button size="sm" variant="danger" @click="removeFile(data.item)">{{ 'home.table.body.remove' | translate }}</b-button>
                                </template>
                            </b-table>
                        </div>
                    </b-card-body>
                </b-card>
            </b-row>
        </div>

        <div v-if="uploading && filesInvalidExtensions.length === 0">
            <b-card>
                <b-card-header>
                    <b>{{ 'home.files.uploading' | translate }}</b>
                </b-card-header>

                <b-card-body>
                    <div class="table-wrapper-scroll-y">
                        <b-table responsive striped hover :items="files" :fields="filesUploadingFields">
                            <template slot="index" slot-scope="data">
                                {{ data.index }}
                            </template>

                            <template slot="name" slot-scope="data">
                                {{ fileNames[data.index] }}
                            </template>

                            <template slot="size" slot-scope="data">
                                {{ data.item.size | bytes }}
                            </template>

                            <template slot="progress" slot-scope="data">
                                <div v-if="!filesErrors[index]">
                                    <div v-if="currentUploadingFile - 1 === data.index">{{ uploadPercentages[data.index] | decimals }}%</div>
                                    <div v-if="currentUploadingFile - 1 < data.index">0%</div>
                                    <div v-if="currentUploadingFile - 1 > data.index">100.00%</div>
                                </div>
                                <div v-if="filesErrors[data.index]">
                                    {{ filesErrors[data.index] }}
                                </div>
                            </template>
                        </b-table>
                        <br>
                    </div>

                    <div>
                        {{ 'home.total.progress' | translate }}:
                    </div>
                    <b-progress :value="totalUploadProgress" show-progress animated></b-progress>

                    <br>

                    <b-button class="float-right" variant="primary" v-show="isUploadFinished" @click="proceedAfterUpload">{{ 'home.continue' | translate }}</b-button>
                    <b-button class="float-right" variant="danger" v-show="!isUploadFinished" @click="cancelUpload">{{ 'home.cancel' | translate }}</b-button>
                </b-card-body>
            </b-card>
        </div>

        <div v-if="publicUploadSuccessful && !assignedUploadSuccessful">
            <b-card>
                <b-card-header>
                    <b>Dateien wurden erfolgreich hochgeladen.</b>
                </b-card-header>

                <b-card-body>
                    Die Dateien können jetzt über folgenden Link öffentlich heruntergeladen werden:
                    <br>
                    <a v-bind:href="link" target="_blank">{{ link }}</a>
                    <br>
                    <br>
                    <p>Des Weiteren können gewünschte Empfänger Automatisch eine E-Mail mit allen wichtigen Information erhalten.</p>
                    <b-form-group label="E-Mails:" label-for="inputPublicEmails">
                        <b-form-input
                            id="inputPublicEmails"
                            type="text"
                            :state="publicEmailsState"
                            v-model="publicUploadMails"
                            placeholder="email1@rautec.de;email2@rautec.de" />

                        <b-form-invalid-feedback>
                            Bitte eine gültige E-Mail, oder mehrere durch ';' getrennte E-Mails, eingeben.
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        label="Sprache"
                        label-for="inputLang"
                    >
                        <b-form-select id="inputLang" @input="loadPublicMailTemplate" v-model="publicTemplateLang" >
                            <option value="de">Deutsch</option>
                            <option value="en">Englisch</option>
                        </b-form-select>
                    </b-form-group>
                    <br>
                    Mögliche Platzhalter: {firstName}, {lastName}, {count}, {link}
                    <b-form-textarea
                        v-model="publicTemplateText"
                        rows="10"
                        max-rows="15"
                    ></b-form-textarea>

                    <b-button variant="secondary" @click="resetUpload">Schließen</b-button>
                    <b-button variant="primary" @click="sendPublicUploadMails" :disabled="!publicEmailsState">E-Mail an Empfänger senden</b-button>
                </b-card-body>
            </b-card>
        </div>

        <b-modal v-model="showRenameFileDialog" id="renameModal" @ok="renameFileConfirm" @cancel="renameFileCancel" title="Dateiname" >
            <b-form-input v-model="renameFileText" type="text"></b-form-input>
        </b-modal>

        <b-modal ok-only v-model="assignedUploadSuccessful" title="Drop" @hidden="resetUpload" @ok="resetUpload">
            {{ 'home.dialog.assigned.upload.successful' | translate }}
        </b-modal>
    </b-container>
</template>

<script>
    import axios from 'axios'
    import Multiselect from 'vue-multiselect'

    export default {
        name: "Home",
        components: { Multiselect },
        data() {
            return {
                files: [],
                filesFields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'name',
                        label: this.$globalStore.translate('home.table.name')
                    },
                    {
                        key: 'size',
                        label: this.$globalStore.translate('home.table.size')
                    },
                    {
                        key: 'rename',
                        label: this.$globalStore.translate('home.table.rename')
                    },
                    {
                        key: 'remove',
                        label: this.$globalStore.translate('home.table.remove')
                    }
                ],
                filesUploadingFields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'name',
                        label: this.$globalStore.translate('files.table.name')
                    },
                    {
                        key: 'size',
                        label: this.$globalStore.translate('files.table.size')
                    },
                    {
                        key: 'progress',
                        label: this.$globalStore.translate('home.files.uploading.progress')
                    }
                ],
                filesErrors: [],
                filesIds: [],
                filesInvalidExtensions: [],
                allowPublicDownload: false,
                selectedEmployee: [],
                employees: [],
                selectedCustomer: [],
                projectGroups: [],
                selectedProjectGroup: [],
                customers: [],
                expireDate: null,
                fileNames: [],
                uploadPercentages: [],
                tooManyFiles: false,
                uploading: false,
                assignedUploadSuccessful: false,
                publicUploadSuccessful: false,
                publicUploadMails: '',
                token: '',
                link: '',
                totalSize: 0,
                loadedBytes: 0,
                totalBytes: 0,
                size: 0,
                start: 0,
                chunks: 0,
                totalChunks: 0,
                chunksUploaded: 0,
                currentChunk: 0,
                //chunkSize: 5242880,
                chunkSize: 2097152,
                lastBytesUploaded: 0,
                currentUploadingFile: 0,
                totalUploadProgress: 0.0,
                filesUploaded: 0,
                uploadCancelled: false,
                isUploadFinished: false,
                publicTemplateText: '',
                publicTemplateLang: 'de',
                showRenameFileDialog: false,
                renameFileText: '',
                renameFileIndex: -1,
                renameFileExtension: ''
            }
        },
        methods: {
            onCustomerSelectOpen: function () {
                this.loadCustomers();
            },
            onEmployeeSelectOpen: function () {
                this.loadEmployees();
            },
            onProjectGroupsSelectOpen: function () {
                axios.get('https://drop.rautec.de/api/projectGroups/all').then(response => {
                    if (response.data.projectGroups) {
                        this.projectGroups = response.data.projectGroups;
                    }
                });
            },
            checkFileAmount: function () {
                if (this.files.length > 15) {
                    this.$toastError('home.dialog.too.many.files', true);
                    return false;
                }

                return true;
            },
            slice: function (file, start, end) {
                let slice = file.mozSlice ? file.mozSlice :
                    file.webkitSlice ? file.webkitSlice :
                        file.slice ? file.slice : noop;

                return slice.bind(file)(start, end);
            },
            submitFiles() {
                if (this.uploading) {
                    return;
                }

                if (!this.checkFileAmount()) {
                    return;
                }

                // Customers are not allowed to upload public, only employees or project groups
                if (this.$globalStore.group === 3) {
                    this.allowPublicDownload = false;

                    // Check if the customer has selected an employee or a project group
                    if (this.selectedEmployee.length === 0 && this.selectedProjectGroup.length === 0) {
                        this.$toastError('home.dialog.only.employee.or.project.group', true);
                        return;
                    }
                } else {
                    // Other users should be able to select customers too and have to select either public upload or assign an user or a project group

                    if (this.allowPublicDownload && (this.selectedEmployee.length > 0 || this.selectedCustomer.length > 0 || this.selectedProjectGroup.length > 0)) {
                        this.$toastError('home.dialog.only.public.or.assign', true);
                        return;
                    } else if (!this.allowPublicDownload && this.selectedEmployee.length === 0 && this.selectedCustomer.length === 0 && this.selectedProjectGroup.length === 0) {
                        this.$toastError('home.dialog.only.public.or.assign', true);
                        return;
                    }
                }

                let formData = new FormData();

                if (this.selectedCustomer.length > 0) {
                    for (let i = 0; i < this.selectedCustomer.length; i++) {
                        let c = this.selectedCustomer[i];

                        formData.append('customers[' + i + ']', c);
                    }
                }

                if (this.selectedEmployee.length > 0) {
                    for (let i = 0; i < this.selectedEmployee.length; i++) {
                        let c = this.selectedEmployee[i];

                        formData.append('employees[' + i + ']', c);
                    }
                }

                if (this.selectedProjectGroup.length > 0) {
                    formData.append('projectGroup', this.selectedProjectGroup);
                }

                formData.append("expire", this.expireDate.getTime() / 1000);
                formData.append("public", this.allowPublicDownload ? 1 : 0);
                formData.append("fileCount", this.files.length);

                this.uploadPercentages = [];

                for (let i = 0; i < this.files.length; i++) {
                    formData.append('files[' + i + ']', this.fileNames[i]);

                    // Calculate the total amount of chunks for the total upload progress
                    this.totalChunks += Math.ceil(this.files[i].size / this.chunkSize);

                    // Initialize the upload percentages
                    this.uploadPercentages[i] = 0;
                }

                this.filesInvalidExtensions = [];
                this.currentUploadingFile = 0;
                this.totalUploadProgress = 0;
                this.uploadCancelled = false;
                this.chunksUploaded = 0;

                axios.post('https://drop.rautec.de/api/file/upload/info', formData).then(response => {
                    if ((response.data.invalidExtensions === null || response.data.invalidExtensions.length === 0) && response.data.files) {
                        this.filesIds = response.data.files;

                        this.uploading = true;

                        this.startFileUpload();
                    } else if (response.data.invalidExtensions) {
                        this.filesInvalidExtensions = response.data.invalidExtensions;
                    }
                });
            },
            startFileUpload: function () {
                if (this.uploadCancelled) {
                    return false;
                }

                if (this.currentUploadingFile < this.files.length) {
                    let f = this.files[this.currentUploadingFile];

                    this.totalBytes = f.size;
                    this.loadedBytes = 0;

                    this.chunks = Math.ceil(f.size / this.chunkSize);
                    this.currentChunk = 1;
                    this.size = f.size;
                    this.start = 0;

                    this.currentUploadingFile++;

                    this.uploadChunkedFile(f);

                    return false;
                } else {
                    return true;
                }
            },
            uploadChunkedFile: function (file) {
                if (this.uploadCancelled) {
                    return;
                }

                let end = this.start + this.chunkSize;
                if (this.size - end < 0) {
                    end = this.size;
                }

                let part = this.slice(file, this.start, end);

                let fd = new FormData();
                fd.append('start', this.start);
                fd.append('end', end);
                fd.append('chunk', this.currentChunk);
                fd.append('chunks', this.chunks);
                fd.append('id', this.filesIds[this.currentUploadingFile - 1]);
                fd.append("file", part);

                this.lastBytesUploaded = end - this.start;

                if (end < this.size) {
                    this.start += this.chunkSize;
                }

                axios.post('https://drop.rautec.de/api/file/upload', fd).then(response => {
                    if (response.data.success === null) {
                        this.filesUploaded++;

                        this.$set(this.filesErrors, this.currentUploadingFile - 1, 'Unbekannter Fehler während des hochladens');

                        if (this.startFileUpload()) {
                            this.uploadFinished(null);
                        }
                        return;
                    }

                    this.loadedBytes += this.lastBytesUploaded;

                    this.uploadPercentages[this.currentUploadingFile - 1] = (this.loadedBytes / this.totalBytes) * 100.0;

                    // If all chunks are sent we can return and start the upload of another file
                    if (this.currentChunk === this.chunks) {
                        this.filesUploaded++;

                        if (this.startFileUpload()) {
                            if (response.data.finished === 1) {
                                this.token = response.data.token;

                                this.uploadFinished();
                            }
                        }

                        return;
                    }

                    this.currentChunk++;
                    this.chunksUploaded++;

                    this.totalUploadProgress = (this.chunksUploaded / this.totalChunks) * 100.0;

                    if (this.currentChunk <= this.chunks) {
                        this.uploadChunkedFile(file);
                    }
                }).catch(error => {
                    this.$set(this.filesErrors, this.currentUploadingFile - 1, 'Fehler während des hochladens: ' + error);

                    if (this.startFileUpload()) {
                        this.uploadFinished(null);
                    }
                })
            },
            uploadFinished: function () {
                this.isUploadFinished = true;

                this.totalUploadProgress = 100;
            },
            cancelUpload: function () {
                this.uploadCancelled = true;

                axios.post('https://drop.rautec.de/api/file/upload/cancel');

                this.uploading = false;
                this.isUploadFinished = false;

                this.filesErrors = [];
                this.filesIds = [];

                this.publicUploadMails = '';
            },
            proceedAfterUpload: function () {
                this.uploading = false;

                if (this.token) {
                    if (!this.allowPublicDownload) {
                        this.publicUploadSuccessful = false;
                        this.assignedUploadSuccessful = true;
                    } else {
                        this.link = 'https://drop.rautec.de/download/' + this.token;
                        this.assignedUploadSuccessful = false;
                        this.publicUploadSuccessful = true;

                        this.loadPublicMailTemplate();
                    }
                } else {
                    this.resetUpload();
                }
            },
            resetUpload: function () {
                this.uploading = false;
                this.isUploadFinished = false;

                this.assignedUploadSuccessful = false;
                this.publicUploadSuccessful = false;

                this.selectedCustomer = [];
                this.selectedEmployee = [];
                this.selectedProjectGroup = [];

                this.allowPublicDownload = false;
                this.token = '';
                this.link = '';
                this.filesErrors = [];
                this.filesIds = [];

                this.publicUploadMails = '';

                this.files = [];
            },
            loadPublicMailTemplate: function () {
                axios.get('https://drop.rautec.de/api/templates/email_public', { params: { lang: this.publicTemplateLang }}).then(response => {
                    if (response.data.text) {
                        this.publicTemplateText = response.data.text;
                    }
                });
            },
            sendPublicUploadMails: function () {
                let formData = new FormData();
                formData.append('fileGroupToken', this.token);
                formData.append('text', this.publicTemplateText);
                let mails = this.publicUploadMails.split(';');
                for (let i = 0; i < mails.length; i++) {
                    formData.append('mails[' + i + ']', mails[i]);
                }

                axios.post('https://drop.rautec.de/api/mail/public/send', formData).then(response => {
                    if (response.data.success === 1) {
                        this.$toastSuccess('E-Mail wurde erfolgreich an die Empfänger gesendet.');
                    } else {
                        this.$toastError('Leider ist ein Problem bei dem E-Mail senden aufgetreten. Bitte versuchen Sie es später erneut.');
                    }

                    this.resetUpload();
                }).catch(error => {
                    this.$toastError('Leider ist ein Problem bei dem E-Mail senden aufgetreten. Bitte versuchen Sie es später erneut.');

                    this.resetUpload();
                });
            },
            removeFile: function (file) {
                let foundIndex = this.files.indexOf(file);

                this.files.splice(foundIndex, 1);
                this.fileNames.splice(foundIndex, 1);

                this.updateTotalSize();
            },
            renameFile: function (file) {
                this.renameFileIndex = this.files.indexOf(file);

                let fileName = this.fileNames[this.renameFileIndex];
                this.renameFileExtension = fileName.substr(fileName.lastIndexOf('.'), fileName.length);
                this.renameFileText = fileName.substr(0, fileName.lastIndexOf('.'));

                this.showRenameFileDialog = true;
            },
            renameFileConfirm: function () {
                this.fileNames[this.renameFileIndex] = this.renameFileText + this.renameFileExtension;
            },
            renameFileCancel: function () {
                this.renameFileText = '';
                this.renameFileExtension = '';
            },
            setDefaultFileNames: function (index) {
                this.fileNames[index] = this.files[index].name;
            },
            handleFilesUpload: function (event) {
                let uploadedFiles = event;

                for (let i = 0; i < uploadedFiles.length; i++) {
                    if (!this.checkFileAmount()) {
                        return;
                    }

                    this.files.push(uploadedFiles[i]);

                    this.setDefaultFileNames(this.files.length - 1);
                }

                this.updateTotalSize();
            },
            updateTotalSize: function () {
                this.totalSize = 0;
                for (let i = 0; i < this.files.length; i++) {
                    this.totalSize += this.files[i].size;
                }
            },
            loadCustomers: function () {
                // Only if customers are not already loaded to save requests
                if (this.customers.length === 0) {
                    axios.get('https://drop.rautec.de/api/users/customers').then(response => {
                        if (response.data.customers) {
                            this.customers = response.data.customers;
                        }
                    });
                }
            },
            loadEmployees: function () {
                // Only if employees are not already loaded to save requests
                if (this.employees.length === 0) {
                    axios.get('https://drop.rautec.de/api/users/employees').then(response => {
                        if (response.data.employees) {
                            this.employees = response.data.employees;
                        }
                    });
                }
            },
            isValidMail: function (email) {
                let mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return mailRegex.test(email.toLowerCase());
            }
        },
        watch: {
            publicTemplateLang: function (value, oldValue) {
                this.loadPublicMailTemplate();
            }
        },
        computed: {
            publicEmailsState: function () {
                let correctMails = this.publicUploadMails.length > 0;
                let mails = this.publicUploadMails.split(';');
                for (let i = 0; i < mails.length; i++) {
                    if (!this.isValidMail(mails[i])) {
                        correctMails = false;
                        break;
                    }
                }

                return correctMails;
            }
        },
        mounted() {
            let expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 28);

            this.expireDate = expireDate;
        }
    }
</script>

<style scoped>
    progress {
        width: 400px;
        display: block;
        margin: 20px auto;
    }

    li {
        width: 50%;
    }

    .table-wrapper-scroll-y {
        display: block;
        max-height: 315px;
        overflow-y: auto;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }

    .card-full-width {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue